import { Component } from '@angular/core';

/**
 * Host enxuto que hospeda o router-outlet da folha, sem sidebar, navbar ou footer.
 * A feature montada e sua destruição são responsabilidade do roteador/módulo da folha.
 */
@Component({
  selector: 'app-leaf-host',
  template: '<router-outlet></router-outlet>',
})
export class LeafHostComponent {}
